import { useEffect } from 'react';
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType
} from 'react-router-dom';
import {
	SENTRY_DSN,
	REACT_APP_ENV,
	REACT_APP_VERSION,
	BASE_JWT_URL
} from 'constants/environmentVariables';
import * as Sentry from '@sentry/react';

export const initSentry = () => {
	Sentry.init({
		dsn: SENTRY_DSN,
		environment: REACT_APP_ENV,
		integrations: [
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes
			}),
			Sentry.replayIntegration({
				maskAllText: true,
				blockAllMedia: true
			}),
			Sentry.captureConsoleIntegration({ levels: ['error'] }),
			Sentry.httpClientIntegration({
				failedRequestStatusCodes: [[500, 599]],
				failedRequestTargets: BASE_JWT_URL ? [BASE_JWT_URL] : []
			}),
			Sentry.reportingObserverIntegration(),
			Sentry.extraErrorDataIntegration()
		],
		ignoreErrors: [/^Warning:/],
		maxBreadcrumbs: 100,
		tracesSampleRate: 0.1,
		release: REACT_APP_VERSION,
		normalizeDepth: 3,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 0.05
	});
};

export const sentryReduxEnhancer = Sentry.createReduxEnhancer({});
